// src/components/charts/DoughnutChart.js (adjust path as needed)
import { Doughnut, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp], // Use the reactiveProp mixin
  props: {
    // chartData prop is provided by the reactiveProp mixin
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    // this.chartData is generated by the mixin.
    // Render the chart with the reactive data and options.
    this.renderChart(this.chartData, this.options);
  }
}